(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $f503f4e8b4654857$exports = {};
$f503f4e8b4654857$exports = axios;


async function $e737e61ed3bec53d$export$90be8af6e408fabe(props) {
    try {
        const axiosResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports)))({
            method: "post",
            url: pm.ajaxurl,
            data: props.formData,
            signal: props.ajaxController.signal
        });
        return axiosResponse.data;
    } catch (error) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f503f4e8b4654857$exports))).isAxiosError(error)) {
            const axiosError = error;
            if (axiosError.response) return axiosError.response.data;
        }
        return {
            success: false,
            errorCode: "unknown_error",
            message: "An unknown error occurred."
        };
    }
}


function $41bb8c76412db878$export$70dc34d9f6ccadfa(artist, wrapper, gridItemToClone) {
    const item = gridItemToClone.cloneNode(true);
    const imageLink = item.querySelector(".artist-list-item-header");
    if (imageLink) {
        imageLink.href = artist.profileUrl;
        imageLink.style.backgroundImage = "url(" + artist.latestPhotoUrl + ")";
    }
    const displayNameEl = item.querySelector("p strong");
    if (displayNameEl) displayNameEl.textContent = artist.displayName;
    const photosCountEl = item.querySelector(".photo-count");
    if (photosCountEl) photosCountEl.textContent = artist.totalPhotos.toString();
    const photoLocationEl = item.querySelector(".photo-location");
    if (photoLocationEl) photoLocationEl.innerHTML = artist.location;
    const viewProfileLink = item.querySelector("p a");
    if (viewProfileLink) viewProfileLink.href = artist.profileUrl;
    const followButton = item.querySelector(".follow-action");
    if (followButton) {
        const buttonTextEl = followButton.querySelector(".button-text");
        if (wrapper.dataset.useFollowingStatus) {
            followButton.dataset.userId = artist.id.toString();
            followButton.dataset.actionType = artist.isFollowing ? "unfollow" : "follow";
            if (buttonTextEl) buttonTextEl.textContent = artist.isFollowing ? "Following" : "Follow";
            if (artist.isFollowing) followButton.classList.add("is-active");
            else followButton.classList.remove("is-active");
        }
    }
    const masonryBreak = wrapper.querySelector(".flexmasonry-break");
    if (masonryBreak) wrapper.insertBefore(item, masonryBreak);
    else wrapper.appendChild(item);
}


function $5ba274ef326e3d65$export$89a0d9497f72d471(photo, wrapper, gridItemToClone, supporterBadgeToClone, proBadgeToClone, superbackerBadgeToClone, insertMode = "append") {
    const { findHtmlEl: findHtmlEl, findLinkEl: findLinkEl } = pm.utils.dom;
    const adId = photo.adId ? photo.adId : 0;
    const isAd = adId > 0;
    const videoUrl = photo.videoUrl;
    const isVideo = videoUrl ? true : false;
    const item = gridItemToClone.cloneNode(true);
    if (!(item instanceof HTMLElement)) return;
    const imageWrapper = findHtmlEl(item, ".grid-image-wrapper");
    if (!imageWrapper) return;
    const img = findHtmlEl(item, ".grid-image");
    const metadata = findHtmlEl(item, ".gallery-metadata");
    const adInfo = findHtmlEl(item, ".spc-info");
    const nicenameEl = findHtmlEl(item, ".gallery-nicename");
    const profileLink = findLinkEl(item, ".gallery-nicename a");
    const caption = findHtmlEl(item, ".photo-caption");
    let photoClassName = "grid-image" + (!isAd ? " has-context-menu photo-popup-trigger" : "");
    const membershipBadge = findHtmlEl(item, ".gallery-nicename .svg-icon-membership-badge");
    let clonedMembershipBadge;
    let catIdsStr = "";
    if (photo.categories.length) {
        catIdsStr = photo.categories.join(", ");
        imageWrapper.dataset.categoryIds = catIdsStr;
    } else imageWrapper.dataset.cateogryIds = "";
    imageWrapper.dataset.largeUrl = photo.urlLarge;
    if (videoUrl) imageWrapper.dataset.videoUrl = videoUrl;
    if (photo.featured) photoClassName += " is-featured";
    if (photo.potd) photoClassName += " assigned-to-potd";
    if (photo.isLiked) photoClassName += " is-liked";
    if (img) {
        if (img.parentNode) img.parentNode.removeChild(img);
    }
    const image = document.createElement("img");
    if (isAd) // Should be before image.src attr is set.
    image.addEventListener("load", function() {
        pm.event.emit("ad_loaded", {
            id: adId
        });
    });
    const imageAlt = photo.imageTitle ? photo.imageTitle : "Photo by " + photo.authorDisplayName;
    image.width = photo.width;
    image.height = photo.height;
    image.className = photoClassName;
    image.src = photo.url;
    image.alt = imageAlt;
    image.dataset.albumSlug = photo.album;
    image.setAttribute("draggable", "true");
    if (isAd) {
        image.addEventListener("load", function() {
            pm.event.emit("ad_loaded", {
                id: adId
            });
        });
        const imageLink = document.createElement("a");
        imageLink.href = photo.attachmentUrl;
        imageLink.target = "_blank";
        imageLink.appendChild(image);
        imageWrapper.insertBefore(imageLink, imageWrapper.firstChild);
        metadata?.parentElement?.removeChild(metadata);
        if (profileLink) {
            if (profileLink.parentNode) profileLink.parentNode.removeChild(profileLink);
        }
    } else {
        if (adInfo) adInfo.parentNode?.removeChild(adInfo);
        if (isVideo && metadata) metadata.innerHTML = '<span class="play-icon"><i class="wpbff wpbff-caret-right"></i></span> Video';
        else {
            const apertureSpan = findHtmlEl(metadata, ".aperture");
            if (apertureSpan) {
                if (photo.aperture && "0" !== photo.aperture) apertureSpan.textContent = "F/" + photo.aperture;
                else apertureSpan.parentElement?.removeChild(apertureSpan);
            }
            const shutterSpeedSpan = findHtmlEl(metadata, ".shutter-speed");
            if (shutterSpeedSpan) {
                if (photo.shutterSpeed && "0" !== photo.shutterSpeed) shutterSpeedSpan.textContent = photo.shutterSpeed;
                else shutterSpeedSpan.parentElement?.removeChild(shutterSpeedSpan);
            }
            const isoSpan = findHtmlEl(metadata, ".iso");
            if (isoSpan) {
                if (photo.iso && "0" !== photo.iso) isoSpan.textContent = "ISO " + photo.iso;
                else isoSpan.parentElement?.removeChild(isoSpan);
            }
        }
        imageWrapper.insertBefore(image, imageWrapper.firstChild);
        if (profileLink) {
            /**
       * This will also remove the trailing slash from pm.siteUrl
       * @link https://stackoverflow.com/questions/6680825/return-string-without-trailing-slash/#answer-6680877
       */ profileLink.href = pm.siteUrl.replace(/\/$/, "") + "/profile/" + photo.authorNicename + "/";
            profileLink.textContent = photo.authorNicename;
        }
        if (caption) caption.innerHTML = photo.description;
    }
    const likeButton = findHtmlEl(item, ".like-photo");
    const buttonTextEl = likeButton ? findHtmlEl(likeButton, ".button-text") : null;
    if (likeButton && wrapper.dataset.useLikeStatus) {
        likeButton.dataset.userId = photo.id.toString();
        if (buttonTextEl) buttonTextEl.textContent = photo.totalLikes > 1 ? "Likes" : "Like";
        if (photo.isLiked) likeButton.classList.add("is-active");
        else likeButton.classList.remove("is-active");
    }
    const deleteButton = findHtmlEl(item, ".delete-photo");
    if (deleteButton) deleteButton.dataset.photoId = photo.id.toString();
    imageWrapper.dataset.photoId = photo.id.toString();
    imageWrapper.dataset.publishedDate = photo.date;
    imageWrapper.dataset.largeUrl = photo.urlLarge;
    imageWrapper.dataset.attachmentUrl = photo.attachmentUrl;
    imageWrapper.dataset.camera = photo.camera;
    imageWrapper.dataset.cameraSlug = photo.cameraSlug;
    imageWrapper.dataset.cameraUrl = photo.cameraUrl;
    imageWrapper.dataset.cameraAlias = photo.cameraAlias;
    imageWrapper.dataset.editableCamera = photo.editableCamera ? "1" : "0";
    imageWrapper.dataset.focalLength = photo.focalLength;
    imageWrapper.dataset.editableFocalLength = photo.editableFocalLength ? "1" : "0";
    imageWrapper.dataset.totalLikes = photo.totalLikes.toString();
    /**
   * Handle the `gulp` running mode.
   *
   * When the local site is running gulp, the photo.attachmentUrl is not converted to port-structured URL.
   * That causes the photo popup fail to open because the actual URL is using port-structured URL,
   * but the photo.attachmentUrl is not.
   */ if (photo.attachmentUrl.indexOf(pm.siteUrl) !== 0) // Let's assume this is a local site running gulp.
    {
        if (photo.attachmentUrl.includes(".local/photo-")) {
            const attachmentUrlSplits = photo.attachmentUrl.split(".local/photo-");
            photo.attachmentUrl = pm.utils.str.stripTrailingSlash(pm.siteUrl) + "/photo-" + attachmentUrlSplits[1];
        }
    }
    imageWrapper.dataset.attachmentUrl = photo.attachmentUrl;
    const locationEl = findHtmlEl(imageWrapper, ".gallery-location");
    if (locationEl) {
        if (isVideo) locationEl.parentElement?.removeChild(locationEl);
        else locationEl.innerHTML = photo.address;
    }
    const galleryAuthor = findHtmlEl(imageWrapper, ".gallery-author");
    if (galleryAuthor) {
        galleryAuthor.textContent = photo.authorDisplayName;
        galleryAuthor.dataset.authorId = photo.authorId.toString();
        galleryAuthor.dataset.authorNicename = photo.authorNicename;
        galleryAuthor.dataset.authorDisplayName = photo.authorDisplayName;
        galleryAuthor.dataset.authorMembershipType = photo.authorMembershipType;
        galleryAuthor.dataset.authorAvatarUrl = photo.authorAvatarUrl;
        galleryAuthor.dataset.authorProfileUrl = photo.authorProfileUrl;
    }
    const headerAvatar = findHtmlEl(imageWrapper, ".grid-item-header .avatar");
    if (headerAvatar instanceof HTMLImageElement) headerAvatar.src = photo.authorAvatarUrl;
    const photoCaptionEl = findHtmlEl(imageWrapper, ".photo-caption");
    if (photoCaptionEl && photo.description) photoCaptionEl.innerHTML = pm.utils.str.wpautop(photo.description, true);
    const rawPhotoCaptionEl = findHtmlEl(imageWrapper, ".raw-photo-caption");
    if (rawPhotoCaptionEl && photo.description) rawPhotoCaptionEl.innerHTML = photo.description;
    if (photo.authorMembershipType) {
        // Only create the badge if it doesn't exist.
        if (!membershipBadge) {
            if (nicenameEl && (supporterBadgeToClone || proBadgeToClone || superbackerBadgeToClone)) {
                if (photo.authorMembershipType === "superbacker" && superbackerBadgeToClone) clonedMembershipBadge = superbackerBadgeToClone.cloneNode(true);
                else if (photo.authorMembershipType === "pro" && proBadgeToClone) clonedMembershipBadge = proBadgeToClone.cloneNode(true);
                else if (supporterBadgeToClone) clonedMembershipBadge = supporterBadgeToClone.cloneNode(true);
                if (clonedMembershipBadge) nicenameEl.appendChild(clonedMembershipBadge);
            }
        }
    } else {
        // Remove badge if it exists.
        if (membershipBadge && membershipBadge.parentNode) membershipBadge.parentNode.removeChild(membershipBadge);
        if (nicenameEl) nicenameEl.textContent = photo.authorNicename;
    }
    const masonryBreak = findHtmlEl(wrapper, ".flexmasonry-break");
    if (insertMode === "append") {
        if (masonryBreak) wrapper.insertBefore(item, masonryBreak);
        else wrapper.appendChild(item);
    } else if (!wrapper.children.length) wrapper.appendChild(item);
    else wrapper.insertBefore(item, wrapper.firstChild);
    if (isAd) {
        item.classList.add("is-spc");
        item.dataset.spcId = photo.adId.toString();
    }
    if (isVideo) item.classList.add("is-video");
    else imageWrapper.removeAttribute("data-video-url");
}


function $3cf207c6114824b2$export$b6f2848a7deea8d1(categories, trendingCategoriesResultWrapper, trendingCategoryItemToClone) {
    if (!trendingCategoryItemToClone) return;
    if (trendingCategoriesResultWrapper) pm.utils.dom.emptyElement(trendingCategoriesResultWrapper);
    const fragment = new DocumentFragment();
    categories.forEach(function(category) {
        const categoryItem = trendingCategoryItemToClone.cloneNode(true);
        const link = categoryItem.querySelector(".category-name");
        if (link) {
            link.href = category.url;
            link.textContent = category.name;
        }
        fragment.appendChild(categoryItem);
    });
    const viewAllItem = trendingCategoryItemToClone.cloneNode(true);
    if (viewAllItem) {
        const viewAlllink = viewAllItem ? viewAllItem.querySelector(".category-name") : null;
        if (viewAlllink) {
            viewAlllink.href = pm.siteUrl + "/categories/";
            viewAlllink.textContent = "View all categories";
        }
        fragment.appendChild(viewAllItem);
    }
    if (trendingCategoriesResultWrapper) trendingCategoriesResultWrapper.appendChild(fragment);
}


function $4c4892d68e9d3814$export$56a2aa631a12288d(camera, wrapper, gridItemToClone) {
    const item = gridItemToClone.cloneNode(true);
    const imageLink = item.querySelector(".card-item-header");
    if (imageLink && imageLink.tagName.toLowerCase() === "a") {
        imageLink.href = camera.url;
        imageLink.style.backgroundImage = "url(" + camera.latestPhotoUrl + ")";
    }
    const cameraNameEl = item.querySelector(".camera-name");
    if (cameraNameEl) cameraNameEl.textContent = camera.aliasedName;
    const photosCountEl = item.querySelector(".photos-count");
    if (photosCountEl) photosCountEl.textContent = camera.totalPhotos.toString();
    const viewPhotosLink = item.querySelector(".view-photos-link");
    if (viewPhotosLink) viewPhotosLink.href = camera.url;
    wrapper.appendChild(item);
}


pm.module.loadMore = function() {
    const { findHtmlEl: findHtmlEl, findHtmlEls: findHtmlEls } = pm.utils.dom;
    const wrapper = findHtmlEl(".use-load-more");
    let ajaxController = null;
    let doingAjax = false;
    let searchKeyword = "";
    let useExtraSearch = false;
    const trendingCategoriesResultWrapper = findHtmlEl(".trending-photo-category-list");
    const $noItemsNotice = jQuery(".no-items-found");
    const elmsToHideOnSearch = findHtmlEls(".hide-on-search");
    const elmsToShowAfterSearch = findHtmlEls(".show-after-search");
    const loadingEl = findHtmlEl(".load-more-anim");
    const pageFooter = findHtmlEl(".wpbf-page-footer");
    const footerHeight = pageFooter ? pageFooter.clientHeight : 0;
    let nextPageNumber = 2;
    let currentPageNumber = nextPageNumber;
    let lastScrollTop = 0;
    let lastId = wrapper && wrapper.dataset.lastId ? parseInt(wrapper.dataset.lastId, 10) : 0;
    let lastTotalPhotos = wrapper && wrapper.dataset.lastTotalPhotos ? parseInt(wrapper.dataset.lastTotalPhotos, 10) : 0;
    const loadMoreType = wrapper && wrapper.dataset.loadMoreType;
    let gridItemToClone;
    switch(loadMoreType){
        case "photo":
            gridItemToClone = findHtmlEl(".elms-to-clone .grid-item");
            break;
        case "artist":
            gridItemToClone = wrapper ? findHtmlEl(wrapper, ".artist-list-item") : null;
            break;
        default:
            gridItemToClone = findHtmlEl(".elms-to-clone .card-item");
            break;
    }
    const trendingCategoryItemToClone = findHtmlEl(".elms-to-clone .trending-photo-category-list-item");
    const supporterBadgeToClone = findHtmlEl(".elms-to-clone .svg-icon-membership-badge.is-supporter");
    const proBadgeToClone = findHtmlEl(".elms-to-clone .svg-icon-membership-badge.is-pro");
    const superbackerBadgeToClone = findHtmlEl(".elms-to-clone .svg-icon-membership-badge.is-superbacker");
    const loadMoreStartDetector = findHtmlEl(".load-more-threshold");
    /**
   * Number of pixel (before reaching the bottom) to trigger the load more earlier.
   */ const loadMoreEarlierPx = (loadMoreStartDetector ? loadMoreStartDetector.clientHeight : 0) + 600;
    let scrollEndReached = false;
    let currentLoadedPhotoIds = [];
    let loadedAdsIds = [];
    const showAds = wrapper && wrapper.dataset.showSpc ? wrapper.dataset.showSpc == "1" : false;
    const excludeViewedPhotos = wrapper && wrapper.dataset.excludeViewedPhotos ? wrapper.dataset.excludeViewedPhotos == "1" : false;
    if (loadMoreType === "photo" && excludeViewedPhotos) {
        const preloadedPhotos = wrapper ? findHtmlEls(wrapper, ".grid-image-wrapper") : [];
        if (preloadedPhotos.length) for(let pIndex = 0; pIndex < preloadedPhotos.length; pIndex++){
            const photoIdStr = preloadedPhotos[pIndex].dataset.photoId;
            const photoId = photoIdStr ? parseInt(photoIdStr, 10) : 0;
            if (photoId) currentLoadedPhotoIds.push(photoId);
        }
    }
    if (loadMoreType === "photo" && showAds) {
        const preloadedAds = wrapper ? findHtmlEls(wrapper, ".grid-item[data-spc-id]") : [];
        for(let aIndex = 0; aIndex < preloadedAds.length; aIndex++){
            const adsIdStr = preloadedAds[aIndex].dataset.spcId;
            const adsId = adsIdStr ? parseInt(adsIdStr, 10) : 0;
            if (adsId) loadedAdsIds.push(adsId);
        }
    }
    window.addEventListener("scroll", checkScrollPosition);
    /**
   * Set the next page number
   *
   * @param number number The next page number.
   */ function setNextPageNumber(number) {
        nextPageNumber = number;
    }
    function setScrollEndReached(state) {
        scrollEndReached = state;
    }
    function setLastScrollTop(position) {
        lastScrollTop = position;
    }
    function setDoingAjax(state) {
        doingAjax = state;
    }
    function setSearchKeyword(keyword) {
        searchKeyword = keyword;
    }
    function enableExtraSearch() {
        useExtraSearch = true;
    }
    function disableExtraSearch() {
        useExtraSearch = false;
    }
    /**
   * Check scrolling position.
   */ async function checkScrollPosition() {
        if (window.scrollY + document.documentElement.clientHeight > document.documentElement.scrollHeight - loadMoreEarlierPx - footerHeight) await doLoadMore();
    }
    /**
   * Start the loading indicator.
   */ function startLoading() {
        if (!loadingEl) return;
        loadingEl.classList.add("is-loading");
    }
    /**
   * Stop the loading indicator.
   */ function stopLoading() {
        if (!loadingEl) return;
        loadingEl.classList.remove("is-loading");
    }
    /**
   * Show the wrapper.
   */ function showWrapper() {
        if (!wrapper) return;
        wrapper.classList.remove("is-hidden");
    }
    /**
   * Hide the wrapper.
   */ function hideWrapper() {
        if (!wrapper) return;
        wrapper.classList.add("is-hidden");
    }
    /**
   * Show the empty items notice.
   */ function showEmptyNotice() {
        $noItemsNotice.stop().fadeIn(150);
    }
    /**
   * Hide the empty items notice.
   */ function hideEmptyNotice() {
        $noItemsNotice.stop().fadeOut(150);
    }
    /**
   * Run the load more ajax request.
   */ async function doLoadMore() {
        if (!wrapper) return;
        if (doingAjax) return;
        if (scrollEndReached) return;
        if (window.scrollY <= lastScrollTop) return;
        lastScrollTop = window.scrollY;
        doingAjax = true;
        hideEmptyNotice();
        startLoading();
        let postData = new FormData();
        postData.append("nonce", pm.nonces.loadMore);
        postData.append("action", "pm_load_more_" + loadMoreType + "s");
        currentPageNumber = nextPageNumber;
        if (currentPageNumber > 1 && lastId > 0) postData.append("last_id", lastId.toString());
        if (searchKeyword) {
            postData.append("search_keyword", searchKeyword);
            if (useExtraSearch) postData.append("use_extra_search", "1");
            hideElementsOnSearch();
            if (currentPageNumber === 1) hideElementsDuringSearch();
        } else hideElementsDuringSearch();
        if (wrapper.dataset.postsPerPage) postData.append("posts_per_page", wrapper.dataset.postsPerPage);
        if (wrapper.dataset.includeIds) postData.append("include_ids", wrapper.dataset.includeIds);
        if (wrapper.dataset.excludeIds) postData.append("exclude_ids", wrapper.dataset.excludeIds);
        if (loadMoreType === "photo") {
            if (wrapper.dataset.profileId) postData.append("profile_id", wrapper.dataset.profileId);
            if (wrapper.dataset.postStatus) postData.append("post_status", wrapper.dataset.postStatus);
            if (wrapper.dataset.useCategories) postData.append("use_categories", "1");
            if (wrapper.dataset.categoryId) postData.append("category_id", wrapper.dataset.categoryId);
            if (wrapper.dataset.cameraName) postData.append("camera_name", wrapper.dataset.cameraName);
            if (wrapper.hasAttribute("data-album-slug") && wrapper.dataset.albumSlug) postData.append("album", wrapper.dataset.albumSlug);
            if (wrapper.dataset.useLikeStatus) postData.append("use_like_status", wrapper.dataset.useLikeStatus);
            if (wrapper.dataset.authorId) postData.append("author_id", wrapper.dataset.authorId);
            if (wrapper.dataset.featured) postData.append("featured", wrapper.dataset.featured);
            const needsFeedback = wrapper.dataset.needsFeedback;
            if (needsFeedback !== undefined) postData.append("needs_feedback", needsFeedback);
            const doneFeedback = wrapper.dataset.doneFeedback;
            if (doneFeedback === "0") postData.append("done_feedback", "0");
            if (wrapper.dataset.excludeViewedPhotos) postData.append("viewed_photo_ids", currentLoadedPhotoIds.join(","));
            if (wrapper.dataset.excludeAuthorIds) postData.append("exclude_author_ids", wrapper.dataset.excludeAuthorIds);
            if (showAds) {
                postData.append("show_ads", "1");
                postData.append("loaded_ads", loadedAdsIds.join(","));
            }
        } else if (loadMoreType === "artist") {
            if (currentPageNumber > 1 && lastTotalPhotos > 0) postData.append("last_total_photos", lastTotalPhotos.toString());
            if (wrapper.dataset.useFollowingStatus) postData.append("use_following_status", wrapper.dataset.useFollowingStatus);
        }
        ajaxController = new AbortController();
        const httpResponse = await (0, $e737e61ed3bec53d$export$90be8af6e408fabe)({
            ajaxController: ajaxController,
            formData: postData
        });
        doingAjax = false;
        ajaxController = null;
        stopLoading();
        const loadMoreData = httpResponse.data;
        if (!searchKeyword) showElementsOnSearchClean();
        showWrapper();
        if (!httpResponse.success) return;
        if (currentPageNumber === 1) {
            let isEmpty = false;
            switch(loadMoreType){
                case "photo":
                    isEmpty = !(loadMoreData && loadMoreData.photos.length);
                    break;
                case "artist":
                    isEmpty = !(loadMoreData && loadMoreData.artists.length);
                    break;
                case "category":
                    isEmpty = !(loadMoreData && loadMoreData.categories.length);
                    break;
                case "camera":
                    isEmpty = !(loadMoreData && loadMoreData.cameras && loadMoreData.cameras.length);
                    break;
            }
            if (isEmpty) {
                showEmptyNotice();
                hideWrapper();
                return;
            }
            pm.utils.dom.emptyElement(wrapper);
        }
        const categories = loadMoreData ? loadMoreData.categories : [];
        const artists = loadMoreData ? loadMoreData.artists : [];
        const photos = loadMoreData ? loadMoreData.photos : [];
        const cameras = loadMoreData && loadMoreData.cameras ? loadMoreData.cameras : [];
        let items = [];
        switch(loadMoreType){
            case "photo":
                items = photos;
                break;
            case "artist":
                items = artists;
                break;
            case "category":
                items = categories;
                break;
            case "camera":
                items = cameras;
                break;
        }
        const existingCategoryResults = trendingCategoriesResultWrapper ? findHtmlEls(trendingCategoriesResultWrapper, ".trending-photo-category-list-item") : [];
        if (loadMoreType === "photo") {
            if (searchKeyword) {
                if (useExtraSearch) {
                    if (!categories.length || !trendingCategoriesResultWrapper || !trendingCategoryItemToClone) hideElementsDuringSearch();
                    else {
                        (0, $3cf207c6114824b2$export$b6f2848a7deea8d1)(categories, trendingCategoriesResultWrapper, trendingCategoryItemToClone);
                        showElementsAfterSearch();
                    }
                } else if (existingCategoryResults.length) showElementsAfterSearch();
            }
        }
        // The scroll reaches the end of items.
        if (!items.length) {
            scrollEndReached = true;
            return;
        }
        const lastItem = items[items.length - 1];
        lastId = lastItem.hasOwnProperty("id") ? lastItem.id : 0;
        if (loadMoreType === "artist") lastTotalPhotos = artists[artists.length - 1].totalPhotos;
        currentLoadedPhotoIds = [];
        if (wrapper && gridItemToClone) items.forEach(function(data) {
            if (loadMoreType === "photo") {
                const photoData = data;
                currentLoadedPhotoIds.push(photoData.id);
                insertPhotoToGrid({
                    photoData: photoData,
                    insertMode: "append"
                });
                if (photoData.adId > 0) loadedAdsIds.push(photoData.adId);
                return;
            }
            if (loadMoreType === "artist") {
                (0, $41bb8c76412db878$export$70dc34d9f6ccadfa)(data, wrapper, gridItemToClone);
                return;
            }
            if (loadMoreType === "camera") {
                (0, $4c4892d68e9d3814$export$56a2aa631a12288d)(data, wrapper, gridItemToClone);
                return;
            }
        });
        if (wrapper.classList.contains("flexmasonry")) {
            // This is for the "search" and "tab switch".
            if (currentPageNumber === 1) {
                // Prevent the flickering effect.
                wrapper.style.opacity = "0";
                /**
         * Wait for few milliseconds until wrapper's display value is flex (with opacity is still 0).
         * This wait is necessary because we call the `showWrapper()` in `ajaxRequest.always` callback.
         */ setTimeout(function() {
                    FlexMasonry.refresh(wrapper);
                    /**
           * Wait for few milliseconds more for the FlexMasonry to refresh.
           * We try to prevent to see the flickering effect.
           */ setTimeout(function() {
                        wrapper.style.opacity = "1";
                    }, 30);
                }, 50);
            } else // Refresh directly. This is for the "load more".
            FlexMasonry.refresh(wrapper);
        }
        jQuery(document).trigger("pm_photos_loaded");
        useExtraSearch = false;
        // The scroll reaches the end of items.
        if (items.length < pm.postsPerPage) {
            scrollEndReached = true;
            return;
        }
        nextPageNumber++;
    }
    function hideElementsDuringSearch() {
        if (!elmsToShowAfterSearch.length) return;
        elmsToShowAfterSearch.forEach(function(el) {
            el.classList.add("is-hidden");
        });
    }
    function showElementsAfterSearch() {
        if (!elmsToShowAfterSearch.length) return;
        elmsToShowAfterSearch.forEach(function(el) {
            el.classList.remove("is-hidden");
        });
    }
    function hideElementsOnSearch() {
        if (!elmsToHideOnSearch.length) return;
        elmsToHideOnSearch.forEach(function(el) {
            el.classList.add("is-hidden");
        });
    }
    function showElementsOnSearchClean() {
        if (!elmsToHideOnSearch.length) return;
        elmsToHideOnSearch.forEach(function(el) {
            if (el.classList.contains("trending-photo-category-list")) {
                if (searchKeyword) el.classList.remove("is-hidden");
                else el.classList.add("is-hidden");
            } else el.classList.remove("is-hidden");
        });
    }
    async function resetPhotosLoad() {
        nextPageNumber = 1;
        lastId = 0;
        lastTotalPhotos = 0;
        scrollEndReached = false;
        lastScrollTop = -1;
        doingAjax = false;
        loadedAdsIds = [];
        if (ajaxController) ajaxController.abort();
        await doLoadMore();
    }
    function insertPhotoToGrid(props) {
        if (!wrapper || !gridItemToClone) return;
        (0, $5ba274ef326e3d65$export$89a0d9497f72d471)(props.photoData, wrapper, gridItemToClone, supporterBadgeToClone, proBadgeToClone, superbackerBadgeToClone, props.insertMode);
    }
    function getTotalPhotos() {
        if (!wrapper) return 0;
        return findHtmlEls(wrapper, ".grid-item").length;
    }
    function refreshGrid() {
        if (!wrapper) return;
        FlexMasonry.refresh(wrapper);
    }
    return {
        setNextPageNumber: setNextPageNumber,
        setScrollEndReached: setScrollEndReached,
        setLastScrollTop: setLastScrollTop,
        setDoingAjax: setDoingAjax,
        ajaxController: ajaxController,
        doLoadMore: doLoadMore,
        showEmptyNotice: showEmptyNotice,
        hideEmptyNotice: hideEmptyNotice,
        resetPhotosLoad: resetPhotosLoad,
        setSearchKeyword: setSearchKeyword,
        enableExtraSearch: enableExtraSearch,
        disableExtraSearch: disableExtraSearch,
        insertPhotoToGrid: insertPhotoToGrid,
        getTotalPhotos: getTotalPhotos,
        refreshGrid: refreshGrid
    };
}();

})();
//# sourceMappingURL=load-more.js.map
